<template src="./search-tag.html"></template>
<script>
import genSearchTag from '../search-tag';
export default genSearchTag({ searchCenter: true });
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import './search-tag.scss';
</style>
